import React, { useMemo, Fragment } from "react"
import useStyles from "./styles"
import { Box, Typography, useMediaQuery, useTheme } from "@material-ui/core"
import {
  clientColumns,
  clientColumnsWithDiscount,
  mobileClientColumns,
} from "../../../../../pages/Shoot/pages/Billing/BillingContext"
import ExpenseTable from "../../../Common/ExpenseTable/index"
import markUpCalc from "../../../../../utils/markUpCalc"
import PropTypes from "prop-types"

const PreviewTable = ({ soloData = {}, showDiscountColumn = false }) => {
  const classes = useStyles()
  const theme = useTheme()
  const mobileView = useMediaQuery(theme.breakpoints.down("xs"))
  const desktopView = useMediaQuery(theme.breakpoints.up("md"))

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  const previewColumns = useMemo(
    () => {
      if (showDiscountColumn && !mobileView) {
        return clientColumnsWithDiscount
      } else if (!showDiscountColumn && !mobileView) {
        return clientColumns
      } else {
        return mobileClientColumns
      }
    },
    [showDiscountColumn, mobileView]
  )

  return (
    <Box className={classes.container}>
      <ExpenseTable
        columns={previewColumns}
        data={(soloData && soloData.roles) || []}
      >
        <ExpenseTable.Header />

        <ExpenseTable.RoleGroup>
          <ExpenseTable.RoleBar />
          <ExpenseTable.ItemsGroup
            style={desktopView ? { marginLeft: 30 } : {}}
          >
            <ExpenseTable.ItemBar>
              <ExpenseTable.NameItem
                style={
                  viewportWidth < 600
                    ? {
                        gridColumn: "1/ span 6",
                      }
                    : {}
                }
              />
              {/* quantity here */}
              {/* quantity input  */}
              {desktopView ? (
                <ExpenseTable.NumberItem valueForProperty="quantity" />
              ) : (
                <Box
                  style={
                    mobileView
                      ? {
                          gridRow: "3/3",
                          gridColumn: "1/1",
                        }
                      : {
                          gridRow: "1/1",
                          gridColumn: "2/2",
                        }
                  }
                >
                  {mobileView && (
                    <Typography className={classes.mobileHeaders}>
                      Quantity
                    </Typography>
                  )}
                  <ExpenseTable.NumberItem valueForProperty="quantity" />
                </Box>
              )}
              {/* quantity input ends  */}
              {/* rate begins */}
              <Box
                style={
                  mobileView
                    ? {
                        gridRow: "3/3",
                        gridColumn: "2/2",
                      }
                    : {
                        gridRow: "1/1",
                        gridColumn: "3/3",
                      }
                }
              >
                {mobileView && (
                  <Typography className={classes.mobileHeaders}>
                    Rate($)
                  </Typography>
                )}
                <ExpenseTable.CalculatedItem>
                  {values =>
                    values.is_percentage
                      ? (
                          Number(
                            values.actual_rate * (values.client_rate / 100)
                          ) + Number(values.actual_rate)
                        ).toFixed(2)
                      : (
                          (values.quantity > 0
                            ? Number(values.client_rate / values.quantity)
                            : Number(values.client_rate)) +
                          Number(values.actual_rate)
                        ).toFixed(2)
                  }
                </ExpenseTable.CalculatedItem>
              </Box>
              {/* rate ends */}
              {/* discount begins */}
              <Fragment>
                {/* Only show discount if a discount exists  in webview */}
                {showDiscountColumn &&
                  !mobileView && (
                    <ExpenseTable.NumberItem valueForProperty="discount" />
                  )}

                {/* Only show discount if a discount exists and its in mobile view */}
                {showDiscountColumn &&
                  mobileView && (
                    <Box
                      style={
                        mobileView
                          ? {
                              gridRow: "3/3",
                              gridColumn: "3/3",
                              justifyContent: "center",
                            }
                          : { gridRow: "2/2", gridColumn: "5/5" }
                      }
                    >
                      <Typography className={classes.mobileHeaders}>
                        Discount($)
                      </Typography>
                      <ExpenseTable.NumberItem valueForProperty="discount" />
                    </Box>
                  )}
              </Fragment>
              {/* discount ends */}
              {/* total starts */}
              <Box
                style={mobileView ? { gridRow: "3/3", gridColumn: "4/4" } : {}}
              >
                {mobileView && (
                  <Typography className={classes.mobileHeaders}>
                    Total($)
                  </Typography>
                )}
                <ExpenseTable.TotalItem>
                  {values =>
                    values.is_percentage
                      ? (
                          Number(values.actual_rate) * Number(values.quantity) +
                          markUpCalc(
                            values.quantity * values.actual_rate,
                            values.client_rate
                          ) -
                          Number(values.discount)
                        ).toFixed(2)
                      : (
                          (values.quantity > 0
                            ? Number(values.client_rate)
                            : 0) +
                          (Number(values.actual_rate) *
                            Number(values.quantity) -
                            Number(values.discount))
                        ).toFixed(2)
                  }
                </ExpenseTable.TotalItem>
              </Box>
              {/* total ends */}

              <ExpenseTable.Item
                valueForProperty="description"
                style={
                  !mobileView
                    ? {
                        gridColumn: "type_name-start / switch-start",
                        gridRow: "2/2",
                      }
                    : {
                        gridRow: "2/2",
                        gridColumn: "1/ span 6",
                      }
                }
              />
              <ExpenseTable.FlagButton hideIfNotFlagged />
            </ExpenseTable.ItemBar>
          </ExpenseTable.ItemsGroup>
        </ExpenseTable.RoleGroup>
      </ExpenseTable>
    </Box>
  )
}

PreviewTable.propTypes = {
  soloData: PropTypes.object,
  showDiscountColumn: PropTypes.bool,
}

export default PreviewTable
